<p-iconfield iconPosition="left" styleClass="w-full">
  <p-inputicon class="pi pi-search" />
  <p-autocomplete
    inputId="topbarPatientSearch"
    [placeholder]="'topbar.patient_search.placeholder' | nymblTranslate"
    [suggestions]="suggestions()"
    (completeMethod)="search($event)"
    [(ngModel)]="selected"
    (onSelect)="onSelect($event)"
    styleClass="w-full"
    [dropdown]="false"
    [forceSelection]="true"
    [showClear]="true"
    dataKey="id"
    optionLabel="label"
  >
    <ng-template #item let-patient>
      <!-- Inactive patients stay selectable, they are only styled differently. -->
      <div
        class="flex items-center gap-4"
        [class.text-red-500]="patient.active === false"
        [class.line-through]="patient.active === false"
      >
        <!-- Distinct per-field spans (not one blended string) so the row reads as
             columns and the Playwright topbar page objects can target each field. -->
        <span class="pat-id">#{{ patient.id }}</span>
        <!-- Name parts are one visual unit: tight gap-1 between them, so the row
             reads as "id | full name | dob" instead of five evenly spaced columns. -->
        <span class="pat-name flex items-center gap-1">
          <span class="pat-first">{{ patient.firstName }}</span>
          @if (patient.middleName) {
            <span class="pat-middle">{{ patient.middleName }}</span>
          }
          <span class="pat-last">{{ patient.lastName }}</span>
        </span>
        @if (patient.dob) {
          <span class="pat-dob">({{ patient.dob | date: 'MM-dd-yyyy' }})</span>
        }
      </div>
    </ng-template>
    <ng-template #empty>
      @if (loading()) {
        <div class="flex flex-col gap-2 p-2">
          @for (_ of [1, 2, 3]; track $index) {
            <p-skeleton class="w-full h-8" />
          }
        </div>
      } @else {
        <div>{{ 'topbar.patient_search.empty' | nymblTranslate }}</div>
      }
    </ng-template>
  </p-autocomplete>
</p-iconfield>
